'use strict';

import angular from 'angular';
import grid from 'angular-ui-grid';
import categorySelect from '../../components/form/element/category/select';

export class CharacteristicComponent {

  closeWindow: Function;

  data;
  characteristic;
  modules;
  module;

  /*@ngInject*/
  constructor($scope, Storage, WindowService, $q) {
    this.Storage = Storage;
    this.scope   = $scope;
    this.Promise = $q.defer;

    this.closeWindow = WindowService.delItem;
  }

  $onInit() {
    this.module         = this.data.module;
    this.characteristic = this.data.characteristic || {
      categoryId: this.data.category._id
    };
  }

  save() {
    return this.Storage.saveCharacteristic(this.characteristic)
      .then(() => this.close())
      .catch(err => console.error(err));
  }

  close() {
    this.closeWindow(this.data.id);
  }
}

export default angular.module('storageApp.characteristic', [
    categorySelect,
  ])
  .component('characteristic', {
    bindings: {data: '='},
    transclude: true,
    template: require('./characteristic.html'),
    controller: CharacteristicComponent,
    controllerAs: 'characteristicCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/characteristic/characteristic.component.js